import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Theme from '../ui/Theme';
import RulesDisplay from './RulesDisplay';
import ShowEmployeeList from './ShowEmployeeList';
import ShowJourneyList from './ShowJourneyList';
import {
  getDepartment,
  getRulesDetails,
  getSelectedRoleID,
  setRulesDetails,
  setRulesListData,
  showProgress,
} from '../../redux/actions/DealershipActions';
import service from '../../apis/service';
import { ErrorToast } from '../utils/Utils';
import { TabNativeContent } from '../common/Tab';
import { apiEndpoints } from '../../constants/apiEndpoints';

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: Theme.palette.secondary.main,
  },
  cardContent: {
    marginRight: '10px',
    marginTop: '10px',
    marginBottom: '10px',
    border: 0,
    backgroundColor: '#F2F4F7',
  },
  scrollContent: {
    marginTop: '10px',
    width: '100%',
    maxHeight: '30vh',
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
  orCondition: {
    textAlign: 'center',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '15px',
    lineHeight: '20px',
  },
  chipOrCondition: {
    textAlign: 'center',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '13px',
    lineHeight: '13px',
  },
  andCondition: {
    textAlign: 'center',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '15px',
    lineHeight: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  chipStyle: {
    backgroundColor: '#F2F4F7',
    marginTop: '5px',
    marginBottom: '5px',
    marginRight: '3px',
    marginLeft: '3px',
  },
  ellipsisMessage: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '250px',
    whiteSpace: 'nowrap',
    display: 'block',
  },
}));

export default function RulesMainContent() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const ruleDetails = useSelector((state) => state.rulesData.selectedRuleDetails);
  const [employeeData, setEmployeeData] = useState([]);

  const [tabId, setTabId] = useState(0);

  useEffect(() => {
    dispatch(getDepartment(0));
    dispatch(getSelectedRoleID(0));
  }, []);

  async function refreshData(id) {
    dispatch(showProgress(true));
    dispatch(getRulesDetails(null));
    await service
      .get(apiEndpoints.RULES_FETCH)
      .then((response) => {
        dispatch(setRulesListData(response));
        dispatch(getRulesDetails(id));
        dispatch(showProgress(false));
      })
      .catch((error) => {
        dispatch(getRulesDetails(id));
        ErrorToast(error);
        dispatch(showProgress(false));
      });
  }

  async function refreshDataEmployee(id) {
    dispatch(showProgress(true));
    await service
      .get(apiEndpoints.RULES_BY_ID.replace('ID', id))
      .then((response) => {
        setEmployeeData(response.employees);
        dispatch(setRulesDetails(response));
        dispatch(showProgress(false));
      })
      .catch((error) => {
        dispatch(showProgress(false));
        ErrorToast(error);
      });
  }

  useEffect(() => {
    if (ruleDetails?.id) {
      setEmployeeData([]);
      refreshDataEmployee(ruleDetails.id);
    }
  }, [ruleDetails?.id]);

  const tabs = [
    { label: `Employees (${ruleDetails?.employees?.length || 0})`, index: 0 },
    { label: `Journeys (${ruleDetails?.journeys?.length || 0})`, index: 1 },
  ];

  return (
    <Grid container style={{ marginTop: '20px' }}>
      <Grid container direction="row" style={{ maxHeight: '30vh', minHeight: '10vh' }}>
        <RulesDisplay scrollContentHeight="30vh" ruleDetails={ruleDetails} />
      </Grid>
      <Grid style={{ height: '2vh' }}>
        <hr />
      </Grid>
      <Grid container direction="row" className={classes.root}>
        <Grid container direction="column">
          <Grid item style={{ maxWidth: '100%' }}>
            <TabNativeContent tabValue={tabId} setTabValue={setTabId} tabs={tabs} />
          </Grid>
          <Grid item>
            {tabId === 0 ? (
              <ShowEmployeeList employees={employeeData} refreshData={() => refreshDataEmployee(ruleDetails.id)} />
            ) : (
              <ShowJourneyList
                journeys={ruleDetails.journeys || []}
                ruleId={ruleDetails.id}
                refreshData={() => refreshData(ruleDetails.id)}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
